import React, {Component} from "react";
import {networkDeviceActions} from "../../../../actions/network-device.actions";
import {daliHelvarActions} from "../../../../actions/dali-helvar.actions";
import BreadcrumbExtend from "../../../../components/BreadcrumbExtend";
import {withNamespaces} from "react-i18next";
import {connect} from "react-redux";
import {Button, Spinner} from "react-bootstrap";
import {Link} from "react-router-dom";
import {deviceGroupActions} from "../../../../actions/device-group.actions";
import DaliHelvarAreaForm from "./_forms/DaliHelvarAreaForm";
import {modalActions} from "../../../../actions/modal.actions";
import DaliHelvarAreaTable from "./_components/DaliHelvarAreaTable";
import DaliDeviceInfo from "../_components/DaliDeviceInfo";

class DaliHelvarAreaPage extends Component {

    componentDidMount() {
        const id = this.props.match.params.id;
        const { dispatch } = this.props;
        dispatch(deviceGroupActions.getDeviceGroup());
        dispatch(networkDeviceActions.getNetworkDeviceSimpleInfo(id));
        dispatch(daliHelvarActions.getHelvarArea(id));
    }

    openModalCreateDaliArea = (e) => {
        e.preventDefault();
        const { t, dispatch, groupList } = this.props;
        const modalProps = {
            open: true,
            title: t('add_dali-area'),
            component: <DaliHelvarAreaForm deviceId={this.props.match.params.id} deviceGroups={groupList} submitForm={this.handleSubmitAddDaliArea} />,
        };
        dispatch(modalActions.showModal({modalProps: modalProps, modalType: 'formModal'}))
    };

    handleSubmitAddDaliArea = (model) => {
        const { dispatch } = this.props;
        dispatch(daliHelvarActions.createHelvarArea(model));
    };

    render() {
        const { t, simpleDeviceInfo,  groupList, loader, helvarAreaList } = this.props;
        const breadcrumb = [
            { value: 'network-device', path: '/panel/network-device' },
            { value: simpleDeviceInfo?.label, path: '#' },
            { value: 'dali-area', path: '#' },
        ];

        return(
            <div>
                <BreadcrumbExtend items={breadcrumb}/>
                <DaliDeviceInfo networkDeviceInfo={simpleDeviceInfo} title={"dali-area"}/>
                { !loader ? (
                    <div className="card">
                        <div className="card-header">
                            <div className="button-group float-right">

                                <Button variant={"success"} onClick={(e) => this.openModalCreateDaliArea(e)}>
                                    <i className="fas fa-plus"/> {t('create')}
                                </Button>
                                &nbsp;
                                <Link className=" btn btn-secondary" to="/panel/network-device" >
                                    <i className="fas fa-undo"> </i> {t('back-to-list')}
                                </Link> &nbsp;
                            </div>
                        </div>
                        <div className="card-body">
                            <DaliHelvarAreaTable list={helvarAreaList} groups={groupList} device={simpleDeviceInfo} />
                        </div>
                    </div>
                ) : (
                    <Spinner animation={"border"} />
                ) }
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    const { simpleDeviceInfo, loader, loaderMsg } = state.networkDeviceReducer;
    const { list: groupList } = state.deviceGroupReducer;
    const { helvarAreaList } = state.daliHelvarReducer;

    return {
        groupList,
        simpleDeviceInfo,
        helvarAreaList,
        loader,
        loaderMsg
    }
};

export default withNamespaces()(connect(mapStateToProps)(DaliHelvarAreaPage));
